import React, {useState} from "react";

import {ITest} from "features/tests/test/components/_interfaces";
import TestStartModal from "features/tests/test/components/TestStartModal";
import TestStarted from "features/tests/test/components/TestStarted";
import TestStartedLiteracy from "features/tests/test/components/TestStartedLiteracy";
import {APIStartTest} from "features/tests/test/api/test";
import {useAuth} from "hooks/useAuth";

const Test = ({test, testFromClient}: { test: ITest, testFromClient: boolean }) => {
    const {update} = useAuth();
    const [testOpened, setTestOpened] = useState<boolean>(test.is_open);
    const [testData, setTestData] = useState<ITest>(test);

    const startTest = () => {
        APIStartTest({test: test.test_id})
            .then((response) => {
                if (response.data.success) {
                    // console.log("getTest OK", response);
                    setTestData(response.data.data.test);
                    setTestOpened(true);
                } else update("error", {show: true, code: "A002"});
            })
            .catch(() => update("error", {show: true, code: "A001"}));
    };

    return (
        !testOpened ?
            <TestStartModal test={testData} startTest={startTest} testFromClient={testFromClient}/> :
            testData.mode === 5 ? <TestStartedLiteracy test={testData} testFromClient={testFromClient}/> :
                <TestStarted test={testData} testFromClient={testFromClient}/>
    )
};

export default Test;
